import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { NavigationBar } from './components/organisms';
import { store } from './store/store';
import { Router } from './router';
import './App.module.scss';
import 'react-toastify/dist/ReactToastify.css';

export function App() {
  return (
    <Provider store={store}>
      <ToastContainer autoClose={5000} position={'top-right'} />
      <div className={'h-100'}>
        <Router>
          <NavigationBar />
          <div style={{ height: '56px' }}></div>
        </Router>
      </div>
    </Provider>
  );
}
